import React from "react";
import ClassNames from "classnames";
import * as s from  "./s.module.scss";

const MultiItemBlock = ({ title, description, variant, children }) => {
  const itemVariant = {
    [s.itemVariant__locations]: variant === "locations",
    [s.itemVariant__perks]: variant === "perks",
    [s.itemVariant__industries]: variant === "industries"
  };

  return (
    <div className={s.multiItemBlock}>
      <div className={s.multiItemBlockWrapper}>
        <div className={s.multiItemBlockTitle}>{title}</div>
        {description && <div className={s.multiItemBlockDescription}>{description}</div>}
        <div className={ClassNames(s.multiItemBlockContent, itemVariant)}>{children}</div>
      </div>
    </div>
  );
};

export default MultiItemBlock;
